import React, { useState, useEffect } from "react";
import { Typography } from "@mui/material";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import swal from "sweetalert";
import * as api from "../../../actions/api";
import ProtocolFormData from "./ProtocolFormData";
import encryptionService from "../../../services/encryptionService";

const EditProtocol = (props) => {
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "protocol";
  const UserInfo = encryptionService.decryptUserInfo();
  const UserName = UserInfo == 0 ? "" : UserInfo[0].name;

  const [selectedProducts, setSelectedProducts] = useState([]);
  const IntervalList = JSON.parse(localStorage.getItem("IntervalList"));

  const [formData, setFormData] = useState({
    code: "",
    RegimenId: "",
    protocolName: "",
    protocolShortName: "",
    protocolType: "",
    ProtocolId: "",
    details: [],
  });

  const [ManyTableData, setManyTableData] = useState([]);

  const [updatedDetailGridData, setUpdatedDetailGridData] = useState([]);
  const [ProtocolId, setProtocolId] = useState("0");
  const [deletedDataSet, setDeletedDataSet] = useState([]);

  const [errorObject, setErrorObject] = useState({});
  const { id } = useParams();
  const queryClient = useQueryClient();

  const { data, refetch } = useQuery(
    ["protocol", id],
    () =>
      api.getProtocol(id).then((res) => {
        setProtocolId(id);
        setFormData(res.data);
        setManyTableData(res.data.ManyJsonSave);
        setUpdatedDetailGridData(res.data.ManyJsonSave);
        console.log("empty setDeletedDataSet");
        setDeletedDataSet([]);
        return res.data;
      }),
    {
      refetchOnWindowFocus: false,
      enabled: Boolean(id),
    }
  );

  const { isLoading, mutate: ProtocolUpdate } = useMutation(
    api.updateProtocol,
    {
      onSuccess: (data) => {
        if (data.status == 200) {
          let route = `${data.data.ProtocolId}`;
          refetch();
          props.history.push(route);

          props.openNoticeModal({
            isOpen: true,
            msg: data.message,
            msgtype: data.success,
          });
        } else {
          props.openNoticeModal({
            isOpen: true,
            msg: data.message,
            msgtype: data.success,
          });
        }

        // if (data.status == 200) {
        //   let route = `${data.data.data.ProtocolId}`;
        //   refetch();
        //   props.history.push(route);
        // }
      },
    }
  );

  const handleAdd = (NonOrderProductData) => {
    setManyTableData(NonOrderProductData);
    //setUpdatedDetailGridData(NonOrderProductData);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
  };

  const handleProductAdd = (NonOrderProductData) => {
    let data = { ...formData };

    data["details"] = NonOrderProductData;
    setFormData(data);

    console.log("Add product in edit page: ", data);
    // setManyTableData(NonOrderProductData)
  };

  const getProductsMutate = useQuery(["products"], api.getProducts);

  const handleReset = () => {
    setFormData({
      code: "",
      RegimenId: "",
      protocolName: "",
      protocolType: "",
    });
  };

  const validateForm = (formData) => {
    let validateFields = ["code", "RegimenId", "protocolName"];
    let errorData = {};
    let isValid = true;
    validateFields.map((field) => {
      if (!formData[field]) {
        errorData[field] =
          DispensingLanguage[lan][menukey]["field is Required !"];
        isValid = false;
      }
    });
    setErrorObject(errorData);
    return isValid;
  };

  const deleteReceiveInv = (data) => {
    console.log(ManyTableData);
    let newarray = ManyTableData.filter((element) => element !== data);

    setManyTableData(newarray);
    if (data.TransactionItemId != null) {
      let newDeletedDataSet = [data.TransactionItemId];
      setDeletedDataSet(newDeletedDataSet.concat(deletedDataSet));
    }
  };

  const deleteProtocolItems = (row) => {
    console.log(row);

    let data = { ...formData };
    console.log(data);

    let newarray = data.details.filter((element) => element !== row);

    data["details"] = newarray;
    setFormData(data);

    let newDeletedDataSet = [row.id];
    setDeletedDataSet(newDeletedDataSet.concat(deletedDataSet));
    console.log("Delete: ", deletedDataSet);
  };

  const handleUpdate = async (e) => {
    if (validateForm(formData)) {
      let FinalData = {
        ...formData,
        ManyJsonSave: ManyTableData,
        menukey: "protocol",
        deletedDataSet: deletedDataSet,
        lan: lan,
        UserName: UserName,
      };
      console.log("update", FinalData);
      ProtocolUpdate(FinalData);
      setFormData(FinalData);
      //swal("Success!", "", "success");
    }
  };

  const handleDetailChange = (e, rowData) => {
    let data = { ...formData };
    let details = [...formData.details];
    const { name, value } = e.target;

    details = details.map((detail) => {
      if (detail.id == rowData.id) {
        detail[name] = value;
      }
      return detail;
    });
    data["details"] = details;
    setFormData(data);
  };

  const handleDetailDropDownChange = (e, rowData) => {
    console.log(
      "Product before update rows when dropdown change in edit page: ",
      rowData
    );
    let data = { ...formData };
    let details = [...formData.details];
    const { name, value } = e.target;

    details = details.map((detail) => {
      if (detail.id == rowData.id) {
        detail[name] = value;

        console.log("IntervalList: ", IntervalList);
        console.log("cur intervalId: ", rowData.intervalId);

        const curInvervalValueObj = IntervalList.filter((intervalRow) => {
          if (rowData.intervalId == intervalRow.id) {
            return intervalRow;
          }
        });
        console.log("curInvervalValueObj: ", curInvervalValueObj);
        console.log("curInvervalValue: ", curInvervalValueObj[0].value);

        // row.qty = rows.qty;
        // row.dur = rows.dur;
        // row.rep = rows.rep;
        let calcQty =
          detail["formulationQty"] *
          detail["dur"] *
          curInvervalValueObj[0].value;
        detail["calc"] = calcQty;
        //detail['productQty'] = calcQty;
      }
      return detail;
    });

    console.log(
      "Product updated rows when dropdown change in edit page: ",
      details
    );
    data["details"] = details;
    setFormData(data);
  };

  const handleDetailCheck = (e, rowData) => {
    let data = { ...formData };
    let details = [...formData.details];
    const { name, checked } = e.target;

    details = details.map((detail) => {
      if (detail.id == rowData.id) {
        detail[name] = checked;
      }
      return detail;
    });
    data["details"] = details;
    setFormData(data);
  };

  const setUpdatedDetailsGridDataHandler = (rows, curcol) => {
    if (curcol === "formulationQty" || curcol === "dur" || curcol === "packs") {
      // console.log('Product before updated rows in edit page: ', rows);
      // console.log('Edited column: ', curcol);

      let data = { ...formData };
      let ManyTableData = data["details"];

      const updateManyTableData = ManyTableData.map((row) => {
        if (row.id == rows.id) {
          if (curcol === "formulationQty" || curcol === "dur") {
            const curInvervalValueObj = IntervalList.filter((intervalRow) => {
              if (rows.intervalId == intervalRow.id) {
                return intervalRow;
              }
            });

            row.formulationQty = rows.formulationQty;
            row.dur = rows.dur;
            //row.rep = rows.rep;
            let calcQty =
              rows.formulationQty * rows.dur * curInvervalValueObj[0].value;
            row.calc = calcQty;
          } else if (curcol === "packs") {
            let calDispQty = "";
            if (rows.packs > 0) {
              calDispQty = rows.PacksizeName * rows.packs;
            }
            row.productQty = calDispQty;
          }
        }
        return row;
      });
      data["details"] = updateManyTableData;
      console.log("Product updated rows in edit page: ", updateManyTableData);
      setFormData(data);
    }
  };

  useEffect(() => {}, [formData]);

  return (
    <>
      <ProtocolFormData
        errorObject={errorObject}
        setFormData={setFormData}
        formData={formData}
        handleChange={handleChange}
        handleCheck={handleCheck}
        handleReset={handleReset}
        handleUpdate={handleUpdate}
        productList={getProductsMutate}
        /* handleDetailChange={handleDetailChange} */
        /* handleDetailDropDownChange={handleDetailDropDownChange} */
        /* handleDetailCheck={handleDetailCheck} */
        selectedProducts={selectedProducts}
        setSelectedProducts={setSelectedProducts}
        productAdd={handleProductAdd}
        setUpdatedDetailsGridDataHandler={setUpdatedDetailsGridDataHandler}
        handleAdd={handleAdd}
        //ManyTableData={updatedDetailGridData}

        deleteReceiveInv={deleteReceiveInv}
        deleteProtocolItems={deleteProtocolItems}
        handleDetailChange={handleDetailChange}
        handleDetailDropDownChange={handleDetailDropDownChange}
        handleDetailCheck={handleDetailCheck}
        /* permissionType={props.permissionType} */

        {...props}
      />
    </>
  );
};

export default EditProtocol;
